module.exports = __webpack_public_path__ + "978a7dfc0b332b8f1aeb65e3b869314b.png";